<template>
    <div>
        <div class="tab-container card">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-if="vendorAllowed" class="head-item" :class="{current : isActiveFlag(1)}" @click="setActiveFlag(1)">供应商</li>
                    <li v-if="servicerAllowed" class="head-item" :class="{current : isActiveFlag(2)}" @click="setActiveFlag(2)">服务商</li>
                    <li v-if="retailerAllowed" class="head-item" :class="{current : isActiveFlag(3)}" @click="setActiveFlag(3)">零售商</li>
                </ul>
            </div>
            <div class="tabs-content" v-if="vendorAllowed" v-show="isActiveFlag(1)">
                <swb-biz-union-vendor-for-select :includeHidden="includeHidden" :ebChannel="ebChannel" :multiSelect="multiSelect" :initCheckedItem="initCheckedItem" :initCheckedItems="initCheckedItems" ref="swb_vendor_for_select"></swb-biz-union-vendor-for-select>
            </div>

            <div class="tabs-content" v-if="servicerAllowed" v-show="isActiveFlag(2)">
                <swb-biz-union-servicer-for-select :ebChannel="ebChannel" :multiSelect="multiSelect" :initCheckedItem="initCheckedItem" :initCheckedItems="initCheckedItems" ref="swb_servicer_for_select"></swb-biz-union-servicer-for-select>
            </div>

            <div class="tabs-content" v-if="retailerAllowed" v-show="isActiveFlag(3)">
                <swb-biz-union-retailer-for-select :ebChannel="ebChannel" :multiSelect="multiSelect" :initCheckedItem="initCheckedItem" :initCheckedItems="initCheckedItems" ref="swb_retailer_for_select"></swb-biz-union-retailer-for-select>
            </div>
        </div>
    </div>

</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import vendorApi from '../../api/vendor'
    import servicerApi from '../../api/servicer'

    import BizUnionVendorForSelect from './BizUnionVendorForSelect';
    Vue.regist(BizUnionVendorForSelect);

    import BizUnionServicerForSelect from './BizUnionServicerForSelect';
    Vue.regist(BizUnionServicerForSelect);

    import BizUnionRetailerForSelect from './BizUnionRetailerForSelect';
    Vue.regist(BizUnionRetailerForSelect);

    export default{
        name: 'swb-biz-union-merchant-select',
        desc: '选择商户列表',
        props: {
            //是否多选
            multiSelect: {
                type: Boolean,
                default: true
            },
            //单选初始选择项
            initCheckedItem: {
                type: Object,
                default: null
            },
            //多选初始选择项
            initCheckedItems: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            vendorAllowed: {
                type: Boolean,
                default: true
            },
            servicerAllowed: {
                type: Boolean,
                default: true
            },
            retailerAllowed: {
                type: Boolean,
                default: true
            },
            // includeHidden 1：只有隐藏商户 0：不包含隐藏商户 -1：包含所有
            includeHidden:{
                type: Number,
                default: 0
            }
        },
        data: function () {
            return {
                //分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                serviceFlag: false,
                goodsFlag: true,
                merchtFlag: 1,
                //
                ebChannel: 'tradeCuohe'
            }
        },
        created: function () {
            //
            this.pageSize = this.pageSizes.first();
            //
            if(this.vendorAllowed) {
                this.setActiveFlag(1);
            } else if(this.servicerAllowed) {
                this.setActiveFlag(2);
            } else if(this.retailerAllowed) {
                this.setActiveFlag(3);
            }
        },
        methods: {
            isActiveFlag(merchtFlag){
                return this.merchtFlag == merchtFlag;
            },
            setActiveFlag(merchtFlag) {
                this.merchtFlag = merchtFlag;
            },
            //
            getResult: function () {
                let self = this;
                let result = {};
                let resultListItem = null;
                let resultListItems = [];
                //
                if(self.vendorAllowed) {
                    let subDlgResult = self.$refs.swb_vendor_for_select.getDlgResult() || {};
                    if(this.multiSelect) {
                        let subList = subDlgResult.data || [];
                        if(subList.length > 0) {
                            resultListItems = subList;
                        }
                    }
                    else {
                        resultListItem = resultListItem || subDlgResult.data || null;
                    }
                } else if(self.servicerAllowed) {
                    let subDlgResult = self.$refs.swb_servicer_for_select.getDlgResult() || {};
                    if(this.multiSelect) {
                        let subList = subDlgResult.data || [];
                        if(subList.length > 0) {
                            resultListItems = subList;
                        }
                    }
                    else {
                        resultListItem = resultListItem || subDlgResult.data || null;
                    }
                } else if(self.retailerAllowed) {
                    let subDlgResult = self.$refs.swb_retailer_for_select.getDlgResult() || {};
                    if(this.multiSelect) {
                        let subList = subDlgResult.data || [];
                        if(subList.length > 0) {
                            resultListItems = subList;
                        }
                    }
                    else {
                        resultListItem = resultListItem || subDlgResult.data || null;
                    }
                }

                if(this.multiSelect) {
                    result.data = resultListItems;
                }
                else {
                    result.data = resultListItem;
                }
                //
                console.log(result);
                //
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizUnion/BizUnionMerchantForSelect.vue